import { render, staticRenderFns } from "./ClassAttachedForm.vue?vue&type=template&id=21544a6c&"
import script from "./ClassAttachedForm.vue?vue&type=script&lang=js&"
export * from "./ClassAttachedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports